import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    forwardRef,
    Inject,
    OnInit,
    Optional,
    ViewEncapsulation
} from '@angular/core';
import { MutationGetListeTagsBibliothequeImageArgs } from 'src/graphql/generated-types';
import gql from 'graphql-tag';
import { tap } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { UntypedFormControl } from '@angular/forms';
import { buildProviders } from '@kalidea/kaligraphi';
import { ImageBankListDialogComponent } from 'src/app/_shared/dialogs/image-bank-dialog/image-bank-list-dialog/image-bank-list-dialog.component';
import { CustomFormControlAccess } from 'src/app/_core/tools/custom-form-control-access';
import { GraphqlService } from 'src/app/_core/services/graphql.service';

@Component({
    selector: 'app-image-bank-filters',
    templateUrl: './image-bank-filters.component.html',
    styleUrls: ['./image-bank-filters.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: buildProviders(ImageBankFiltersComponent),
    standalone: false
})
export class ImageBankFiltersComponent extends CustomFormControlAccess implements OnInit {

    tagControl = new UntypedFormControl(null);

    tagsList: string[] = [];

    constructor(@Optional() @Inject(forwardRef(() => ImageBankListDialogComponent)) private bankListComponent: ImageBankListDialogComponent,
                private graphqlService: GraphqlService,
                private store: Store,
                private cdr: ChangeDetectorRef) {
        super();
    }

    writeValue(value: any): void {
        super.writeValue(value);
        this.tagControl.patchValue(value, {emitEvent: false});
        this.cdr.markForCheck();
    }

    applyFilters() {
        super.notifyUpdate(this.tagControl.value);
        this.closeFilters();
    }

    closeFilters() {
        this.bankListComponent.toggleFilters();
    }

    private getTagsList(): void {
        this.graphqlService.mutateOne<'GetListeTagsBibliothequeImage', MutationGetListeTagsBibliothequeImageArgs>({
            mutation: gql`
                mutation getTagsList($contexte: ContextInfosInput) {
                    GetListeTagsBibliothequeImage(contexte: $contexte) {
                        string
                    }
                }
            `,
        })
        .pipe(
            this.untilDestroyed,
            tap((GetListeTagsBibliothequeImage) => this.tagsList = GetListeTagsBibliothequeImage?.string || [])
        ).subscribe();
    }

    ngOnInit() {
        this.getTagsList();
    }

}
